// extracted by mini-css-extract-plugin
export default {"centerSidebar__buttons":"CenterSidebar_centerSidebar__buttons__Y7s34"};